import { z } from 'zod';
export const accountEmailSchema = z
  .string()
  .trim()
  .toLowerCase()
  .email('Enter a valid email')
  .max(254);
export const temporaryPasswordSchema = z
  .string()
  .min(12, 'Use at least 12 characters')
  .max(64)
  .refine(
    (value) => new TextEncoder().encode(value).length <= 72,
    'Password exceeds the supported byte limit',
  );
export const createLoginSchema = z
  .object({
    full_name: z.string().trim().min(2).max(120),
    email: accountEmailSchema,
    role: z.enum(['admin', 'staff']),
    staff_id: z.string().uuid().nullable().optional(),
    permissions: z.array(z.string()).max(120),
    password_mode: z.enum(['generate', 'manual']),
    temporary_password: temporaryPasswordSchema.optional(),
    email_attested: z.literal(true),
  })
  .superRefine((value, context) => {
    if (value.password_mode === 'manual' && !value.temporary_password)
      context.addIssue({
        code: 'custom',
        path: ['temporary_password'],
        message: 'Enter a temporary password',
      });
  });
export const accessReasonSchema = z.string().trim().min(3).max(500);
